import AbstractMediator from "../../../core/ui/AbstractMediator";
import SmartphoneSoundType from "./SmartphoneSoundType";
import SmartphoneNavigateEvent from "../model/SmartphoneNavigateEvent";

export default class AbstractSmartphoneMediator extends AbstractMediator {
    constructor(target, dispatcher, layoutManager, clickEaterFactory) {
        super(target, dispatcher, layoutManager, clickEaterFactory);
    }

    createInterfaceButton(skin, boundClickHandler, label) {
        return super.createButton(skin, boundClickHandler, label, SmartphoneSoundType.SOUND_SMARTPHONE_CLICK);
    }

    getGotoScreenRequest(screenType, screen, autoCenter, priority, needsOverlay, openUnderCurrent, animationType, animationOptions) {
        return new SmartphoneNavigateEvent(SmartphoneNavigateEvent.GOTO_SCREEN_REQUEST, screenType, screen, autoCenter, priority, needsOverlay, openUnderCurrent, animationType, animationOptions);
    }

    getOpenScreenRequest(screenType, screen, autoCenter, priority, needsOverlay, openUnderCurrent, animationType, animationOptions) {
        return new SmartphoneNavigateEvent(SmartphoneNavigateEvent.OPEN_SCREEN_REQUEST, screenType, screen, autoCenter, priority, needsOverlay, openUnderCurrent, animationType, animationOptions);
    }

    getCloseScreenRequest(screenType, screen, autoCenter, priority, needsOverlay, openUnderCurrent, animationType, animationOptions) {
        return new SmartphoneNavigateEvent(SmartphoneNavigateEvent.CLOSE_SCREEN_REQUEST, screenType, screen, autoCenter, priority, needsOverlay, openUnderCurrent, animationType, animationOptions);
    }
}